import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { deviceLogFolders } from './queryKeys';
import envVars from '../../../../constants/envVars';
import useQueryRequestParams from '../../../../hooks/useQueryRequestParams';
const useGetDeviceLogFolders = (props, enabled) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_CLOUD_HOSTNAME}backoffice/logs-on-demand/list`, {
            ...additional,
            params: { ...props }
        }),
        queryKey: [deviceLogFolders, props.device_id, props.offset, props.limit],
        placeholderData: keepPreviousData,
        enabled,
        retry: false,
        refetchOnWindowFocus: false
    });
};
export default useGetDeviceLogFolders;
